<template>
  <div class="authForm">
    <b-tabs class="authForm__wrapper" no-key-nav>
      <div class="authForm__label">
          <img
            v-if="customLogo"
            :src="customLogo"
            alt="Tangle"
            class="authForm__customLogo"
          >
          <img
            v-else-if="logoLoaded && !customLogo"
            src="@/assets/imgs/logo.png"
            alt="Tangle"
          >
        <img
          v-if="authInProgress"
          src="@/assets/imgs/gifs/loading.gif"
          class="authForm__inProgress"
          alt="loading"
          >
      </div>
      <b-tab
        v-if="!isUserAnonymous"
        title="Sign in"
        :active="activeForm === 1"
        >
        <sign-in />
      </b-tab>
      <b-tab
        title="Sign up"
        :active="activeForm === 2"
        >
        <sign-up />
      </b-tab>
      <div class="authForm__anonymous">
        <b-button
          style="display:none"
          variant="success"
          @click="signInAsAnonymously"
          v-if="!isUserAnonymous"
          >
          <b>Try it now</b>
        </b-button>
      </div>
    </b-tabs>
  </div>
</template>

<script>
// components
import SignIn from './SignIn'
import SignUp from './SignUp'
// modules
import { mapState } from 'vuex'
// services
import auth from '@/services/auth'
import db from '@/services/db'

export default {
  components: {
    SignIn,
    SignUp
  },
  data () {
    return {
      activeForm: 1,
      customLogo: localStorage.getItem('logo'),
      logoLoaded: false
    }
  },
  computed: {
    ...mapState([
      'authInProgress',
      'isUserAnonymous'
    ])
  },
  methods: {
    signInAsAnonymously () {
      this.$store.commit('addProcess', {
        process: 'signIn'
      })
      auth.signInAsAnonymously((err) => {
        this.$store.commit('deleteProcess', 'signIn')
        if (err) this.$store.commit('addError', err.message)
        else this.$router.push('/home')
      })
    }
  },









async created () {



    if (!this.userId) {
      await new Promise((resolve, reject) => {
        db.root.ref(`dashboards/-LJvhjWDjl6xyPGlag1H/widgetsData/config`)
          .once('value', (snapshot) => {
            const demoConfig = snapshot.val()
            var a = demoConfig.demos
            var domain = document.domain
            console.log(domain)
            var ret = _.find(a, function(o) {
                    return o.domain === domain;
            })
            console.log(ret)

            if(typeof ret !== "undefined")
            var logo = ret.Logo
            {

                this.customLogo = ret.logo
                localStorage.setItem('logo', ret.logo)
                console.log('set logo to ' + ret.logo)

            }

            resolve()
          }, (err) => {
            reject(err)
          })
      }).catch((err) => {
        console.error(err)
      })
    }

    this.logoLoaded = true

    if (this.$route.path === '/auth/anonymous' && !this.isUserAnonymous) {
      this.$router.push('/auth')
    }



  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.authForm {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: {
    top: 30px;
    bottom: 30px;
  }
  &__wrapper {
    width: 300px;
  }
  &__label {
    position: relative;
    text-align: center;
    padding: {
      top: 15px;
      bottom: 10px;
    }
    border-bottom: 1px solid $borderColor2;
    margin-bottom: 10px;
  }
  &__inProgress {
    position: absolute;
    right: -3px;
    top: 76px;
    width: 35px;
    height: 35px;
  }
  .tab-content {
    border: 1px solid $borderColor1;
    border-top: 0;
    margin-top: -1px;
    padding: 0 15px 15px 15px;
  }
  &__submit {
    width: 100%;
  }
    &__customLogo {
    height: 50px;
  }
  &__anonymous {
    padding-top: 10px;
    .btn {
      width: 100%;
    }
  }
}
.authLogo{
      max-height: 60px;
}
.oauth {
  display: none;
  display: flex;
  margin-bottom: 15px;
  &__link {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  &__img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/index.vue